import { UserRole } from "./roles";

const ROLE_CLAIM_KEY = "http://schemas.microsoft.com/ws/2008/06/identity/claims/role";

const toRole = (role: string): UserRole | undefined => {
  switch (role.trim().toLowerCase()) {
    case "superadmin":
      return UserRole.SuperAdmin;
    case "admin":
      return UserRole.Admin;
    case "user":
      return UserRole.User;
    default:
      return undefined;
  }
};

const readClaimRoles = (value: unknown): UserRole[] => {
  if (typeof value === "string") {
    return value
      .split(",")
      .map((item) => toRole(item))
      .filter((item): item is UserRole => item !== undefined);
  }

  if (Array.isArray(value)) {
    return value
      .filter((item): item is string => typeof item === "string")
      .map((item) => toRole(item))
      .filter((item): item is UserRole => item !== undefined);
  }

  return [];
};

export const deriveRoleFromClaims = (
  claims: Record<string, unknown>
): UserRole | undefined => {
  const roles = [
    ...readClaimRoles(claims[ROLE_CLAIM_KEY]),
    ...readClaimRoles(claims.role),
    ...readClaimRoles(claims.roles),
  ];

  if (roles.includes(UserRole.SuperAdmin)) {
    return UserRole.SuperAdmin;
  }
  if (roles.includes(UserRole.Admin)) {
    return UserRole.Admin;
  }
  if (roles.includes(UserRole.User)) {
    return UserRole.User;
  }

  return undefined;
};
